import React from 'react';
import { Paper, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	paper: {
		position: 'absolute',
		minWidth: '75%',
		maxHeight: '90%',
		padding: theme.spacing(4),
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		overflowY: 'scroll',
	},
}));

const ModalContentContainer = ({ open, handleClose, children }) => {
	const classes = useStyles();
	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="simple-modal-title"
			aria-describedby="simple-modal-description"
		>
			<div>
				<Paper className={classes.paper}>{children}</Paper>
			</div>
		</Modal>
	);
};

export default ModalContentContainer;
